module.exports = __webpack_public_path__ + "static/media/8 Patidar 2020 YGBKD Brief.b2f2bd78.pdf";